import React from 'react'
import "./HeadingB.css"

export default function HeadingB({text, className}) {
    return (
    <p className={`${className} ft_lg text-e forNavHeading`} 
    style={{color:"#1976D2", fontWeight: "600" ,fontSize: "20px", lineHeight: "30px"}} >{text}</p>
    )
}
